import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./performance.css";

const useCountUp = (target, duration = 1500, started) => {
  const [count, setCount] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!started) return;

    setCount(0);
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        setCount(target);
      }
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [started, target, duration]);

  return count;
};

const MetricItem = ({ target, prefix = "", suffix = "", label, started }) => {
  const count = useCountUp(target, 1500, started);
  return (
    <div className="metric-item">
      <h2 className="metric-value">{prefix}{count}{suffix}</h2>
      <p className="metric-label" dangerouslySetInnerHTML={{ __html: label }} />
    </div>
  );
};

const PerformanceSection = () => {
  const [started, setStarted] = useState(false);
  const sectionRef = useRef(null);
  const lastScrollY = useRef(window.scrollY);

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true });
    AOS.refresh();

    const observer = new IntersectionObserver(
      ([entry]) => {
        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY >= lastScrollY.current;
        lastScrollY.current = currentScrollY;

        if (entry.isIntersecting && scrollingDown) {
          // Entered viewport scrolling down → trigger counter
          setStarted(prev => !prev); // toggle to force re-trigger
        }
        // Scrolling up past section → do nothing, keep numbers
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="performance-container" ref={sectionRef}>
      <div className="performance-content">
        <div className="performance-header" data-aos="fade-up">
          <h1 className="performance-title">
            Desempenho com
            <br />
            <span className="performance-highlight">resultados visíveis</span>
          </h1>
        </div>

        <div className="metrics-grid" data-aos="fade-up">
          <MetricItem target={56} suffix="+" label="Propriedades<br/>Geridas" started={started} />
          <MetricItem target={2} suffix="M€+" label="Valor de<br/>Arrendamento" started={started} />
          <MetricItem target={90} suffix="%+" label="Retenção<br/>de Clientes" started={started} />
        </div>
      </div>
    </div>
  );
};

export default PerformanceSection;